import Vue from 'vue'
import Router from 'vue-router'
const Home = r => require.ensure([], () => r(require("../pages/Home/Home")), "home")
const MediaList = r => require.ensure([], () => r(require("../pages/MediaList/MediaList")), 'medialist')
const AdvertList = r => require.ensure([], () => r(require("../pages/AdvertList/AdvertList")), 'advertlist')
const MediaData = r => require.ensure([], () => r(require("../pages/MediaData/MediaData")), 'mediadata')
const AdvertData = r => require.ensure([], () => r(require("../pages/AdvertData/AdvertData")), 'advertdata')
const FinanceInfo = r => require.ensure([], () => r(require("../pages/FinanceInfo/FinanceInfo")), 'financeinfo')
const FinanceAdd = r => require.ensure([], () => r(require("../pages/Finance/add")), 'financeadd')
const FinanceEdit = r => require.ensure([], () => r(require("../pages/Finance/edit")), 'financeedit')
const FinanceDetail = r => require.ensure([], () => r(require("../pages/Finance/detail")), 'financedetail')
const FinanceDeposit = r => require.ensure([], () => r(require("../pages/Finance/deposit")), 'financedeposit')

const DepositRecord = r => require.ensure([], () => r(require("../pages/DepositRecord/DepositRecord")), 'depositrecord')
const Documents = r => require.ensure([], () => r(require("../pages/Documents/Documents")), "documents")
const Sdkdown = r => require.ensure([], () => r(require("../pages/Sdkdown/Sdkdown")), "sdkdown")
const PutLimit = r => require.ensure([], () => r(require("../pages/PutLimit/PutLimit.vue")), "putlimit")
const AddMediaList = r => require.ensure([], () => r(require("../pages/AddMediaList/AddMediaList")), "addmedialist")
const AddAdvertList = r => require.ensure([], () => r(require("../pages/AddAdvertList/AddAdvertList")), "addavertlist")
const AdvertDataDetail = r => require.ensure([], () => r(require("../pages/AdvertDataDetail/AdvertDataDetail")), "advertdatadetail")
const MediaDataDetail = r => require.ensure([], () => r(require("../pages/MediaDataDetail/MediaDataDetail")), "mediadatadetail")
const EditorAdvert = r => require.ensure([], () => r(require('../pages/EditorAdvert/EditorAdvert')), 'editoradvert')

const AccountCenter = r => require.ensure([], () => r(require("../pages/AccountCenter/AccountCenter")), "accountcenter")
const ModifyPassword = r => require.ensure([], () => r(require("../pages/AccountCenter/ModifyPassword")), "modifypassword")
const DeliveryRestrictList = r => require.ensure([], () => r(require("../pages/DeliveryRestrictList/DeliveryRestrictList")), "deliveryrestrictlist")
const DownloadList = r => require.ensure([], () => r(require("../pages/DownloadList/DownloadList")), "downloadlist")

const Account = r => require.ensure([], () => r(require("../pages/User/User")), "user")
const Login = r => require.ensure([], () => r(require("../pages/User/Login/Login")), "login")
const Register = r => require.ensure([], () => r(require("../pages/User/Register/Register")), "register")
const Retrieve = r => require.ensure([], () => r(require("../pages/User/Retrieve/Retrieve")), "retrieve")

const NewHome = r => require.ensure([], () => r(require("../pages/NewHome/newHome")), "newhome")
const Flow = r => require.ensure([], () => r(require("../pages/NewHome/Flow/Flow")), "flow")
const Advertising = r => require.ensure([], () => r(require("../pages/NewHome/Advertising/Advertising")), "advertising")
const ProductCenter = r => require.ensure([], () => r(require("../pages/NewHome/ProductCenter/ProductCenter")), "productcenter")
const AboutUs = r => require.ensure([], () => r(require("../pages/NewHome/AboutUs/AboutUs")), "aboutus")
const SDK = r => require.ensure([], () => r(require("../pages/NewHome/SDK/sdk")), "sdk")
const AndroidSDK = r => require.ensure([], () => r(require("../pages/NewHome/SDK/AndroidSDK")), "androidsdk")
const IosSDK = r => require.ensure([], () => r(require("../pages/NewHome/SDK/IosSDK")), "iossdk")
const KyySDK = r => require.ensure([], () => r(require("../pages/NewHome/SDK/kyySDK")), "kyysdk")
const AndroidSDKUp = r => require.ensure([], () => r(require("../pages/NewHome/SDK/AndroidSDKUp")), "androidsdkup")
const IosSDKUp = r => require.ensure([], () => r(require("../pages/NewHome/SDK/IosSDKUp")), "iossdkup")
const KyySDKUp = r => require.ensure([], () => r(require("../pages/NewHome/SDK/kyySDKUp")), "kyysdkup")
const TermsService = r => require.ensure([], () => r(require("../pages/NewHome/TermsService/TermsService")), "termsservice")
const TermsPrivacy = r => require.ensure([], () => r(require("../pages/NewHome/TermsService/TermsPrivacy")), "termsprivacy")

Vue.use(Router)
export default new Router({
	mode: "history",
	routes: [{
			//新首页
			path: "/",
			name: "newhome",
			component: NewHome,
		},
		{
			//流量主
			path: "/publish",
			name: "flow",
			component: Flow
		},
		{
			//广告主
			path: "/advertiser",
			name: "advertising",
			component: Advertising
		},
		{
			//产品中心
			path: "/sdk",
			name: "productcenter",
			component: ProductCenter
		},
		{
			//关于我们
			path: "/about",
			name: "aboutus",
			component: AboutUs
		},
		{
			//sdk
			path:"/sdkdoc",
			component:SDK,
			children:[
				{
					//安卓sdk
					path:'androidsdk',
					name:'androidsdk',
					component: AndroidSDK,
				},
				{
					//安卓sdk日志
					path:'androidsdkup',
					name:'androidsdkup',
					component: AndroidSDKUp,
				},
				{
					//ios sdk
					path: "iossdk",
					name: "iossdk",
					component: IosSDK
				},
				{
					//ios 日志
					path: "iossdkup",
					name: "iossdkup",
					component: IosSDKUp
				},
				{
					//kyy sdk
					path: "kyysdk",
					name: "kyysdk",
					component: KyySDK
				},
				{
					//kyy sdk
					path: "kyysdkup",
					name: "kyysdkup",
					component: KyySDKUp
				}
			]
		},
		{
			//媒体服务条款
			path: "/termsservice",
			name: "TermsService",
			component: TermsService
		},
		{
			//隐私条款
			path: "/termsprivacy",
			name: "termsprivacy",
			component: TermsPrivacy
		},
		{
			//首页
			path: "/index",
			name: "home",
			component: Home
		}, {
			//账号中心
			path: "/accountCenter/accountCenter",
			name: "accountCenter",
			component: AccountCenter
		}, {
			//修改密码
			path: "/accountCenter/modifyPassword",
			name: "modifyPassword",
			component: ModifyPassword
		}, {
			//媒体列表
			path: "/mediaManage/appList",
			name: "mediaList",
			component: MediaList
		}, {
			//添加媒体
			path: "/mediaManage/appList/addApp/:id",
			name: "addMediaList",
			component: AddMediaList
		}, {
			//广告位列表
			path: "/mediaManage/advertList",
			name: "advertList",
			component: AdvertList
		}, {
			//添加广告位
			path: "/mediaManage/advertList/addadvertlist/:id",
			name: "addadvertlist",
			component: AddAdvertList
		}, {
			//编辑广告位
			path: "/mediaManage/advertList/editoradvert/:id",
			name: "editorAdvert",
			component: EditorAdvert
		}, {
			//投放限制
			path: "/mediaManage/deliveryRestrictList/putLimit/:id",
			name: "putLimit",
			component: PutLimit
		}, {
			//媒体数据
			path: "/statistics/mediaData",
			name: "mediaData",
			component: MediaData
		}, {
			//媒体数据详情
			path: "/statistics/mediaData/detail",
			name: "mediaDataDetail",
			component: MediaDataDetail
		}, {
			//广告位数据
			path: "/statistics/advertData",
			name: "advertData",
			component: AdvertData
		}, {
			//广告位数据详情
			path: "/statistics/advertData/detail",
			name: "advertDataDetail",
			component: AdvertDataDetail
		}, {
			//财务信息列表
			path: "/finance/financeInfo",
			name: "financeInfo",
			component: FinanceInfo
		},
		{
			//财务信息添加
			path: "/finance/financeInfo/add",
			name: "financeAdd",
			component: FinanceAdd,
		},
		{
			//财务信息编辑
			path: "/finance/financeInfo/edit",
			name: "financeEdit",
			component: FinanceEdit,
		},
		{
			//财务信息详情
			path: "/finance/financeInfo/detail",
			name: "financeDetail",
			component: FinanceDetail,
		},
		{
			//财务信息提现
			path: "/finance/financeInfo/deposit",
			name: "financeDeposit",
			component: FinanceDeposit,
		},
		{
			//财务提现记录
			path: "/finance/depositRecord",
			name: "depositRecord",
			component: DepositRecord
		},
		{
			//对接文档
			path: "/documents",
			name: "documents",
			component: Documents
		},
		{
			//sdk下载文档
			path: "/sdkdown",
			name: "sdkdown",
			component: Sdkdown
		},
		{
			//投放限制列表
			path: "/mediaManage/deliveryRestrictList",
			name: "deliveryRestrictList",
			component: DeliveryRestrictList
		},
		{
			// 媒体数据 分发广告 下载明细
			path: "/downloadList",
			name: "downloadList",
			component: DownloadList
		},
		//      {
		//          // 重定向到登录
		//          path: '/',
		//          redirect: '/account/login'
		//      },
		{
			// 登陆、注册
			path: "/account",
			name: "account",
			component: Account,
			children: [{
					path: "login",
					name: "login",
					component: Login
				},
				{
					path: "register",
					name: "register",
					component: Register
				},
				{
					path: "retrieve",
					name: "retrieve",
					component: Retrieve
				}
			]
		},
		// {
		// 	// 重定向到新首页
		// 	path: '/',
		// 	redirect: {name: 'newhome'}
		// },
	],
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
		return savedPosition
		} else {
		return { x: 0, y: 0 }
		}
	}
})



// WEBPACK FOOTER //
// ./src/router/index.js